import React from 'react'

import Chart from './MarblesLegend.d3'
import ChartWrapper from '../ChartWrapper'

const MarblesLegend = ({ data, setMarblesData, activeNode, isCompanyPage }) => {
  const updateProps = React.useMemo(() => ({ data, activeNode }), [
    data,
    activeNode,
  ])

  return (
    <ChartWrapper
      Chart={Chart}
      initProps={{ data, setMarblesData, activeNode, isCompanyPage }}
      updateProps={updateProps}
    />
  )
}

export default MarblesLegend
